<template>
	<div class="region-listing">
		<div
			ref="map"
			style="width: 100%; height: 50rem"
			class="region-listing__map">
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import $http from 'axios'
import { mapStyles, loadGoogleMaps } from './../../utils'

export default {
	data() {
		return {
			state: this.$store.state,
			regionListing: [],
			map: null,
			markers: [],
			clusterer: null,
			infoWindow: null,
		}
	},
	props: {
		mapData: {
			type: Array
		},
		mapSuburb: {
			type: Object
		},
	},
	methods: {
		async initMap() {
			await loadGoogleMaps()
			if (!this.$refs.map) return

			this.map = new google.maps.Map(this.$refs.map, {
				center: { lat: parseFloat(this.mapSuburb.lat), lng: parseFloat(this.mapSuburb.lng) },
				zoom: 14,
				styles: mapStyles,
			})
			this.infoWindow = new google.maps.InfoWindow()
			this.addMarkers()
		},
		addMarkers() {
			this.clearMarkers()
			const fallbackIcon = '/dist/images/markers/marker-flat.svg'
			const iconSize = new google.maps.Size(42, 52)

			this.regionListing.forEach((item) => {
				if (!item.position || !item.position.lat || !item.position.lng) return
				const iconUrl = item.icon || fallbackIcon
				const marker = new google.maps.Marker({
					position: { lat: parseFloat(item.position.lat), lng: parseFloat(item.position.lng) },
					map: this.map,
					icon: { url: iconUrl, scaledSize: iconSize },
				})

				// Some business categories have no dedicated marker SVG — fall back to
				// the default pin if the category icon can't be loaded so the marker
				// still shows instead of rendering as an invisible/broken image.
				if (iconUrl !== fallbackIcon) {
					const probe = new Image()
					probe.onerror = () => marker.setIcon({ url: fallbackIcon, scaledSize: iconSize })
					probe.src = iconUrl
				}

				marker.addListener('click', () => this.toggleInfoWindow(item, marker))
				this.markers.push(marker)
			})

			// Cluster markers if the library is available on window
			if (window.MarkerClusterer) {
				if (this.clusterer) this.clusterer.clearMarkers()
				this.clusterer = new window.MarkerClusterer(this.map, this.markers)
			}

			this.setMapBounds()
		},
		clearMarkers() {
			if (this.clusterer) {
				this.clusterer.clearMarkers()
				this.clusterer = null
			}
			this.markers.forEach(m => m.setMap(null))
			this.markers = []
		},
		toggleInfoWindow(marker, gmapMarker) {
			const iwOuter = $('.gm-style-iw')
			const iwBackground = iwOuter.prev()
			iwOuter.parent().addClass('info-window')
			iwBackground.children(':nth-child(1), :nth-child(2), :nth-child(3), :nth-child(4)').css({ display: 'none' })

			let content = `
				<div class="info-window__container">
					<div class="info-window__content">
						<div class="info-window__title">${marker.title}</div>

						<div class="info-window__line">
							<span class="info-window__icon icon icon-map-marker"><svg><use href="#icon-map-marker"/></svg></span>
							<div class="info-window__text">${marker.address}</div>
						</div>

						<div class="info-window__line">
							<span class="info-window__icon icon icon-phone"><svg><use href="#icon-phone"/></svg></span>
							<div class="info-window__text">${marker.phone}</div>
						</div>`

			if (marker.email != null) {
				content += `
						<div class="info-window__line">
							<span class="info-window__icon icon icon-email"><svg><use href="#icon-email"/></svg></span>
							<a href="${marker.email}" class="info-window__text" target="_blank">${marker.email}</a>
						</div>`
			}

			content += `
						<div class="info-window__line">
							<span class="info-window__icon icon icon-link"><svg><use href="#icon-link"/></svg></span>
							<a href="${marker.website}" class="info-window__text" target="_blank">Visit website</a>
						</div>`

			if (marker.callToAction != null) {
				content += `
						<div class="info-window__line info-window__call-to-action">
							<a href="${marker.callToAction.link}" target="_blank" class="link link--withicon">
								<span class="link__text">${marker.callToAction.text}</span>
								<span class="link__icon">
									<span class="icon icon-splotch-3 link__splotch"><svg><use href="#icon-splotch-3" /></svg></span>
									<span class="icon icon-chevron--right link__symbol"><svg><use href="#icon-chevron--right" /></svg></span>
								</span>
							</a>
						</div>`
			}

			if (marker.sublistings && marker.sublistings.length > 0) {
				content += `<div class="info-window__sublistings">Also at this location</div>`
				marker.sublistings.forEach(sub => {
					content += `
						<div class="info-window__subtitle">${sub.title}</div>
						<div class="info-window__line">
							<span class="info-window__icon icon icon-phone"><svg><use href="#icon-phone"/></svg></span>
							<div class="info-window__text">${sub.phone}</div>
						</div>
						<div class="info-window__line">
							<span class="info-window__icon icon icon-email"><svg><use href="#icon-email"/></svg></span>
							<a href="${sub.email}" class="info-window__text" target="_blank">${sub.email}</a>
						</div>
						<div class="info-window__line">
							<span class="info-window__icon icon icon-link"><svg><use href="#icon-link"/></svg></span>
							<a href="${sub.website}" class="info-window__text" target="_blank">Visit website</a>
						</div>`
				})
			}

			content += `</div></div>`

			this.infoWindow.setContent(content)
			this.infoWindow.open(this.map, gmapMarker)
		},
		getRegionListItems() {
			this.regionListing = this.mapData
		},
		setMapBounds() {
			if (!this.map || !this.regionListing.length) return
			const bounds = new google.maps.LatLngBounds()
			this.regionListing.forEach(item => {
				if (item.position && item.position.lat && item.position.lng) {
					bounds.extend(new google.maps.LatLng(
						parseFloat(item.position.lat),
						parseFloat(item.position.lng)
					))
				}
			})
			this.map.fitBounds(bounds)
		},
	},
	mounted() {
		this.getRegionListItems()
		this.initMap()
	},
}
</script>
